import { useCallback, useContext, useEffect } from 'react';

import { MessagingContext } from '@sorare/wallet-shared';
import type { Prompt } from '@sorare/wallet-shared';
import type { WalletLoaded } from '@sorare/wallet-shared/src/contexts/messaging';

import { useMessagingContext } from '#src/contexts/wallet/index.ts';
import {
  WalletTab,
  useWalletDrawerContext,
} from '#src/contexts/walletDrawer/index.tsx';
import { useEvents } from '#src/lib/events/useEvents.ts';

export const useOAuthEthWallet = () => {
  const { sendRequest } = useContext(MessagingContext)!;
  const { setCurrentTab, showWallet, hideWallet } = useWalletDrawerContext();
  const track = useEvents();
  const { registerHandler } = useMessagingContext();

  const promptGenerateKeys = useCallback(async () => {
    setCurrentTab(WalletTab.GENERATE_KEYS);
    showWallet();
    track('View Set Wallet Password');
    await sendRequest<Prompt>('prompt', {
      type: 'generateKeys',
    });
  }, [sendRequest, setCurrentTab, showWallet, track]);

  useEffect(() => {
    registerHandler<WalletLoaded>('walletLoaded', async () => {
      setCurrentTab(WalletTab.HOME);
      hideWallet();
      return {};
    });
  }, [registerHandler, setCurrentTab, hideWallet]);

  return {
    promptGenerateKeys,
  };
};
